function initMobileFlickity() {
  const sliderContainer = document.querySelector('.floating-reviews-section__columns');
  if (!sliderContainer) return null;

  // Clear inline heights left over from a previous Flickity instance so that
  // Flickity can measure natural content heights instead of inheriting 100% of
  // a now-destroyed viewport (which resolves to 0 and collapses all cards).
  sliderContainer.querySelectorAll('.floating-reviews-section__col').forEach(col => {
    col.style.height = '';
  });

  const isMobile = () => window.matchMedia("(max-width: 480px)").matches;

  function safePlay(video) {
    if (!video) return;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function primeReviewVideo(video) {
    if (!video || video.dataset.loaded === 'true') return;
    const src = video.dataset.src;
    if (!src) return;

    const source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.dataset.loaded = 'true';
    video.load();
  }

  function syncVisibleReviewVideos() {
    const videos = sliderContainer.querySelectorAll('.js-video[data-src]');
    videos.forEach((video) => {
      const rect = video.getBoundingClientRect();
      const isVisible = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;

      if (isVisible) {
        primeReviewVideo(video);
        video.muted = true;
        safePlay(video);
      } else {
        video.pause();
      }
    });
  }

  function setupLazyReviewVideos() {
    const videos = sliderContainer.querySelectorAll('.js-video[data-src]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      syncVisibleReviewVideos();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            primeReviewVideo(video);
            video.muted = true;
            safePlay(video);
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '150px 0px', threshold: 0.15 }
    );

    videos.forEach((video) => observer.observe(video));
  }

  // Remove specific slides only once, but only on mobile
  if (!sliderContainer.dataset.secondRemoved && isMobile()) {
    const secondSlide = sliderContainer.querySelector(':scope > *:nth-child(2)');
    const sevenSlide  = sliderContainer.querySelector(':scope > *:nth-child(7)');
    const fiveSlide   = sliderContainer.querySelector(':scope > *:nth-child(5)');
    if (secondSlide) { secondSlide.remove(); sliderContainer.dataset.secondRemoved = "true"; }
    if (sevenSlide)  { sevenSlide.remove();  sliderContainer.dataset.sevenRemoved  = "true"; }
    if (fiveSlide)   { fiveSlide.remove();   sliderContainer.dataset.fiveRemoved   = "true"; }
  }

  const options = {
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    pauseAutoPlayOnHover: false,
    prevNextButtons: false,
    imagesLoaded: true,
    groupCells: (() => {
      if (isMobile()) return false;
      if (window.matchMedia("(max-width: 1200px)").matches) return 2;
      return 5;
    })(),
    adaptiveHeight: false,
    pageDots: false,
    on: {
      ready() {
        document.querySelectorAll('.floating-reviews-section__col')
          .forEach(cell => { cell.style.height = '100%'; });
      }
    }
  };

  if (isMobile()) options.autoPlay = 8000;

  const flkty = new Flickity(sliderContainer, options);
  setupLazyReviewVideos();
  const viewport = sliderContainer.querySelector('.flickity-viewport');
  if (!viewport) return flkty;

  // Smooth transition on mobile (or move to CSS)
  viewport.style.transition = viewport.style.transition || 'height .28s ease';

  // ===== MOBILE-ONLY HEIGHT ADAPTATION =====
  const MEASURE_SELECTORS = [
    '.product-review__header',
    '.product-review__text-container'
  ];
  const INCLUDE_MARGINS = true;

  let observers = [];
  let rafId = null;

  function clearObservers() {
    observers.forEach(ro => ro.disconnect());
    observers = [];
  }

  function getMeasureTargets(cell) {
    const targets = MEASURE_SELECTORS
      .map(sel => cell.querySelector(sel))
      .filter(Boolean);
    return targets.length ? targets : [cell];
  }

  function getOuterHeight(el) {
    let h = el.scrollHeight || 0;
    if (INCLUDE_MARGINS) {
      const cs = getComputedStyle(el);
      h += (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
    }
    return h;
  }

  function measureHeight(cell) {
    return getMeasureTargets(cell).reduce((sum, el) => sum + getOuterHeight(el), 0);
  }

  function revealActive(cell) {
    document.querySelectorAll('.floating-reviews-section__col.is-expanded')
      .forEach(el => el.classList.remove('is-expanded'));
    if (cell) cell.classList.add('is-expanded');
  }

  function setViewportHeightFromCell(cell) {
    viewport.style.height = measureHeight(cell) + 22 + 'px';
  }

  function attachObservers(cell) {
    clearObservers();
    getMeasureTargets(cell).forEach(t => {
      const ro = new ResizeObserver(() => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => setViewportHeightFromCell(cell));
      });
      ro.observe(t);
      observers.push(ro);
    });
  }

  function updateHeight() {
    if (!isMobile()) return; // Only on mobile
    const cell = flkty.selectedElement;
    if (!cell) return;
    revealActive(cell);
    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      setViewportHeightFromCell(cell);
      attachObservers(cell);
    });
  }

  // Fire when ready and on change
  flkty.on('ready', updateHeight);
  flkty.on('select', () => {
    updateHeight();
    requestAnimationFrame(syncVisibleReviewVideos);
  });
  flkty.on('settle', () => {
    updateHeight();
    requestAnimationFrame(syncVisibleReviewVideos);
  });

  // Desktop custom arrows
  if (!isMobile()) {
    const prevBtn = document.querySelector('.flickity-custom-prev');
    const nextBtn = document.querySelector('.flickity-custom-next');
    if (prevBtn) prevBtn.addEventListener('click', () => flkty.previous());
    if (nextBtn) nextBtn.addEventListener('click', () => flkty.next());
  }

  // Keep autoplay running on touch (mobile)
  if (isMobile()) {
    const play = () => flkty.player && flkty.player.play();
    flkty.on('pointerDown', play);
    flkty.on('pointerUp', play);
    flkty.on('staticClick', play);
  }

  // Cleanup before destroy
  flkty._autoHeightDetach = clearObservers;
  flkty._syncVisibleReviewVideos = syncVisibleReviewVideos;
  return flkty;
}

function getBreakpoint() {
  if (window.matchMedia('(max-width: 480px)').matches) return 'mobile';
  if (window.matchMedia('(max-width: 1200px)').matches) return 'tablet';
  return 'desktop';
}

let flickityInstance = initMobileFlickity();
let currentBreakpoint = getBreakpoint();

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    const newBreakpoint = getBreakpoint();

    if (newBreakpoint !== currentBreakpoint) {
      // Breakpoint crossed — groupCells or autoPlay needs to change, full reinit
      currentBreakpoint = newBreakpoint;
      if (flickityInstance) {
        if (flickityInstance._autoHeightDetach) flickityInstance._autoHeightDetach();
        flickityInstance.destroy();
        flickityInstance = null;
      }
      flickityInstance = initMobileFlickity();
    } else if (flickityInstance) {
      // Same breakpoint — just update layout
      flickityInstance.resize();
      if (flickityInstance._syncVisibleReviewVideos) flickityInstance._syncVisibleReviewVideos();
    }
  }, 200);
});
